import { logger } from '../../common/logger';

const allowedTags = [
  'html',
  'body',
  'article',
  'p',
  'h1',
  'h2',
  'h3',
  'ul',
  'li',
  'strong',
  'i',
  'em',
  'span',
  'div',
  'br',
];

const allowedAttributes = ['class', 'id'];

export const createMarkup = (html: string) => {
  try {
    const doc = new window.DOMParser().parseFromString(html, 'text/html');
    const els = doc.getElementsByTagName('*');

    Array.from(els).forEach(el => {
      if (allowedTags.includes(el.tagName.toLowerCase())) {
        Array.from(el.attributes).forEach(attr => {
          if (!allowedAttributes.includes(attr.name.toLowerCase())) {
            el.removeAttribute(attr.name);
          }
        });
      } else {
        el.remove();
      }
    });

    const sanitizedHtml = doc.getElementsByTagName('body')[0]?.innerHTML || '';

    return sanitizedHtml;
  } catch (e) {
    logger.info(e as object);

    return '<!-- html sanitation failed -->';
  }
};
